import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/faq/New-user-guide-q2-02.png")